<template>
  <div class="mod">
    <!-- 奖励弹窗 -->
    <div class="mod_box" v-show="type && !fx">
      <div class="mod_text">{{ info.text }}</div>
      <img class="ap mod_img" v-show="!info.quna" :src="info.img" alt="" />
      <div class="quan" v-show="info.quna">
        <img :src="info.img" class="quanimg" alt="">
        <!-- <div class="quan_left">
          <text>¥</text>
          <text class="quan_Price">{{ info ? info.info.rate : "" }}</text>
        </div>
        <div class="quan_right">
          <div>{{ info ? info.info.name : "" }}</div>
          <div>{{ info ? info.info.content : "" }}</div>
        </div> -->
      </div>
      <div v-show="info.quna" class="quan_text">详情至我的-优惠券中查看</div>
      <img class="receive" @click="setUser" :src="info.btn" />
    </div>
    <!-- 合成 -->
    <div class="mod_box2" v-show="!type && !fx">
      <img class="receive2" @click="synthesis" :src="img" />
    </div>

    <!-- 分享引导 -->
    <img v-show="fx" :src="fxmg" @click="synthesis" class="nod_box3" />
  </div>
</template>

<script>
import img from "../utils/img";
export default {
  name: "Mod",
  data() {
    return {
      img: img.img22,
      fxmg: img.img29,
      // 奖励
    };
  },
  props: {
    type: Boolean,
    info: Object,
    fx: Boolean,
  },
  mounted: function () {},
  methods: {
    setUser: function () {
      this.$emit("transfer", false); //将值绑定到transfer上传递过去
    },
    // 合成
    synthesis: function () {
      this.$emit("synthesis");
    },
  },
};
</script>

<style scoped lang="scss">
/* mod */
.mod {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.431);
  z-index: 90;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mod_box {
  width: 80%;
  height: 68%;
  background-image: url("https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/About/mod-min.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.mod_box2 {
  width: 86%;
  height: 48%;
  background-image: url("https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/jh-min.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.mod_text {
  width: 100%;
  margin-top:16vh;
  text-align: center;
  font-size: 20px;
  color: #a274f2;
  // line-height: 40px;
  font-weight: 600;
  min-height: 60px;
}
.mod_img {
  width: 150px;
  height: 180px;
  margin: 0 auto;
}
.receive {
  width: 200px;
  height: 44px;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 30px;
}
.receive2 {
  width: 200px;
  height: 44px;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 30px;
}
.quan {
  width: 80%;
  height: 80px;
  // background-image: url("https://vpcimage.oss-cn-beijing.aliyuncs.com/0yaoking-cn-wxapp/h5hd/home/quan-min.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 20px auto;
  display: flex;
  align-items: center;
  color: #7439e2;
  font-size: 14px;
}
.quan_text {
  color: #7439e2;
  width: 100%;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
}
.quan_left {
  height: 100%;
  width: 32%;
display: flex;
align-items: center;
justify-content: center;
}
.quan_right {
  // height: 100%;
  width: 68%;
  padding: 10px;
  box-sizing: border-box;
}
.quan_right > div {
  height:50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.quan_Price {
  font-size: 20px;
}
.nod_box3 {
  width: 250px;
  height: 300px;
  margin-bottom: 60%;
}
.quanimg{
  width: 100%;
  height: 100%;
}
</style>
